module.exports = __webpack_public_path__ + "d739f359a9cd79648eaed18cb4cd2b55.pdf";